import { AccessArgs } from "types/accessRules";
import { accessRules } from "utils/accessRules";

type AccessCheckResult = {
  accessDenied: boolean;
  message?: string;
};

export const useHasAccess = (pageKey: string, args?: AccessArgs): AccessCheckResult => {
  const ruleFn = accessRules[pageKey];

  if (!ruleFn) {
    return { accessDenied: false };
  }

  return ruleFn(args ?? {});
};
